var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools02-accounts"},[_c('el-row',[_c('el-col',[(_vm.tool.codeKebab === 'microsoft-cv')?_c('h2',[_vm._v(" マネージャーアカウント 一覧 ")]):(_vm.tool.codeKebab === 'smartnews-cv')?_c('h2',[_vm._v("ビジネスマネージャー一覧")]):_c('h2',[_vm._v("広告アカウント一覧")])])],1),_c('el-row',[_c('el-col',[_c('Tools02AccountsAccountList')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }